import { Comic } from "./comic.class";
import { Rectangle } from "./rectangle.class";
import { FormatoPagina, PADROES_PAGINA } from "../api/documento.types";

/**
 * A FOLHA QUE NASCE COM OS QUADROS QUE O SEU NOME PROMETE.
 *
 * O T1.21 do pedido é um POSITIVO com sugestão: o modal de templates da Kaori "está legal de
 * usar, pelo menos como editor de templates", e a sugestão é incorporar aspectos dele no editor
 * de quadrinhos. Eu nunca vi aquele modal — ele não existe neste repositório, e o nome aparece
 * só nos documentos do ticket. O que dá para separar da peça que não vi é a ideia dela: começar
 * de um arranjo pronto em vez de uma folha em branco.
 *
 * E havia um buraco medido esperando exatamente isso. Em produção, em 10/09, com conta real:
 * escolher "Página de revista — A4. Cabe de 4 a 6 quadros" abre a folha VAZIA. As seis opções
 * do seletor mudavam só a dimensão do papel; a distinção entre "Página de revista" e "Grade
 * livre — sem grade pronta" não existia no comportamento, embora existisse no texto.
 *
 * ── POR QUE ISTO NÃO MORA DENTRO DE `Comic` ─────────────────────────────────────────────────
 *
 * Seria o lugar óbvio, e não dá: `rectangle.class` importa `ItemMenuContainer` de
 * `comic.class`. Se `comic.class` importasse `Rectangle` de volta, o ciclo fecharia. Este
 * módulo é a terceira ponta — importa os dois e nenhum dos dois o importa.
 */
export function comicComGradeInicial(formato: FormatoPagina, nome?: string): Comic {
  const padrao = PADROES_PAGINA[formato];
  const comic = Comic.getEmptyComic(padrao.largura, padrao.altura);

  // T8.29 · O NOME CHEGA AQUI, e não mais só na hora de salvar.
  //
  // Ele: "Pedir junto com o formato evita o modal e já permite o salvamento automático." A segunda
  // metade é a que importa no código: o salvamento automático precisa de um nome para ter o que
  // gravar, e antes disto o nome só existia depois do primeiro Salvar manual.
  //
  // Vazio continua sendo válido: quem não nomeia no começo nomeia ao salvar, como antes.
  if (nome?.trim()) comic.Name(nome.trim());

  for (const quadro of padrao.grade) {
    comic.addItem(
      0,
      new Rectangle({
        id: "",
        // As frações viram pixels AQUI, contra a dimensão real da folha — e arredondadas, para
        // que o quadro caia no pixel e não em 341.7.
        x: Math.round(quadro.x * padrao.largura),
        y: Math.round(quadro.y * padrao.altura),
        width: Math.round(quadro.w * padrao.largura),
        height: Math.round(quadro.h * padrao.altura),
        rotation: 0,
        mirror: false,
        imgId: "",
        // O mesmo "Quadro comum" que o botão Inserir Quadro oferece primeiro: traço grosso,
        // preto, fundo branco, canto reto. Uma grade que nascesse com um estilo que a barra não
        // oferece seria uma segunda linguagem visual sem motivo.
        borderWidth: 6,
        borderColor: "#000000",
        fillColor: "#ffffff",
        cornerRadius: 0,
      })
    );
  }

  return comic;
}
